import styled from "styled-components";
import BoxShadows from "../style-vars/BoxShadows";

const Card = styled.div`
    box-shadow: ${BoxShadows.CARD};
    padding: 10px 15px;
    background: white;
    border-radius: 4px;
`
export default Card;